module.exports = __webpack_public_path__ + "474ffc2b8b1b9094c4b09ee15493b4ee.jpg";